export default __webpack_public_path__ + "09b3b23c30f26cd82bfb8c4c4677ccb9.svg";